import { EVIDENCE_PHOTO_EXTENSIONS } from "./evidence-photos.constants";

export const extensionOf = (name: string) =>
  name.includes(".") ? name.split(".").pop()?.toLowerCase() ?? "" : "";

export const isEvidencePhoto = (file: { name: string }) =>
  EVIDENCE_PHOTO_EXTENSIONS.includes(extensionOf(file.name ?? ""));
